var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTmQue = function SvgTmQue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.5 4.375h-15a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h15a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625M10.392 8.542H2.5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h7.892a.624.624 0 1 1 0 1.25M17.5 12.708h-15a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h15a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625M10.392 16.875H2.5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h7.892a.624.624 0 1 1 0 1.25"
  })));
};
export default SvgTmQue;